import './core/ydk.config';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { initPegasus } from './core/pegasus';
import App from './App';

import './index.css';

// 埋点注入
initPegasus();

// 只在测试环境|预发 开启Vconsole
if (['staging', 'development'].includes(process.env.REACT_APP_MY_ENV || '')) {
  const VConsole = require('vconsole');
  new VConsole();
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
